export default {
  "root": "_root_1xq93_1",
  "item": "_item_1xq93_1"
};import "ni:sha-256;OEw-LfhIlz9dLlb26gFk1Bq-5SfJZopBywwavdAF_jM";